/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreExternalCostCreateDto } from '../../models/core-external-cost-create-dto';
import { CoreExternalCostResponseDto } from '../../models/core-external-cost-response-dto';

export interface ExternalCostsControllerCreate$Params {

/**
 * Tenant identifier
 */
  tenant: string;
      body: CoreExternalCostCreateDto
}

export function externalCostsControllerCreate(http: HttpClient, rootUrl: string, params: ExternalCostsControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreExternalCostResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, externalCostsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreExternalCostResponseDto>;
    })
  );
}

externalCostsControllerCreate.PATH = '/o2-core/external-costs/{tenant}';
